import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect, useMemo } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import { removeWidget } from "../../redux/supervisorSlice";
import WidgetTools from "./widgetTools";
import ArrayStore from "devextreme/data/array_store";
import DataSource from 'devextreme/data/data_source';
import {
    DataGrid, Column, StateStoring, Paging, Sorting, SearchPanel, Scrolling
} from 'devextreme-react/data-grid';
import { selectionTypes } from "src/components/utils/consts";
import WidgetSettings from "./widgetSettings";

function CampaignsStats(props) {

    const { t } = useTranslation();
    const [campaigns, setCampaigns] = useState(0);
    const [showSettings, setShowSettings] = useState(false);
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);

    const dataSource = useMemo(() => {
        return new DataSource({
            store: new ArrayStore({
                key: 'campaignId',
                data: []
            }),
            reshapeOnPush: true
        })
    }, []);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {


                MonitorWSService.stompClient.send(`/user/topic/campaignsstats/`, {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe(`campaignsstats`);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        if (props.connected) {
            let campaigns = JSON.parse(localStorage.getItem(`CampaignsStats_camps_${props.identifier}_user${props.id}`) || "[]");
            setSelectedCampaigns(campaigns);

            MonitorWSService.stompClient.send("/app/subscribe/campaignsstats", {}, JSON.stringify({
                token: props.token
            }));

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/campaignsstats/`, updateState, { id: "campaignsstats" });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const updateState = (campaigns) => {
        if (!document.hidden) {
            let data = JSON.parse(campaigns.body);
            let selected = JSON.parse(localStorage.getItem(`CampaignsStats_camps_${props.identifier}_user${props.id}`) || "[]");
            if (selected?.length > 0) {
                data = data.filter(x => selected.indexOf(x.campaignId) > -1);
            }

            let campaignsIds = dataSource.items().map(x => x.campaignId);

            campaignsIds.forEach(x => {
                if (data.map(c => c.campaignId).indexOf(x) === -1) {
                    dataSource.store().push([{ type: 'remove', key: x }]);
                }
            });

            data.forEach(v => {
                if (campaignsIds.indexOf(v.campaignId) > -1) {
                    dataSource.store().push([{ type: 'update', key: v.campaignId, data: v }]);
                } else {
                    dataSource.store().push([{ type: 'insert', data: v }]);
                }
            });

            setCampaigns(data.length);
        }
    }

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setCampaignsFilter = (campaigns) => {
        localStorage.setItem(`CampaignsStats_camps_${props.identifier}_user${props.id}`, JSON.stringify(campaigns));
        setShowSettings(!showSettings);
        setSelectedCampaigns(campaigns);
        MonitorWSService.stompClient.send("/app/subscribe/campaignsstats", {}, JSON.stringify({
            token: props.token
        }));
    };

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} id="campaignsstatswidget">

            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("table-cells")} /> {t("campaignsstats")} <span className="badge badge-light-primary fs-base">{campaigns}</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>

            <div className="card-body" style={{ padding: "0px", height: "360px" }} >
                <DataGrid
                    id="campaignsstatstable"
                    dataSource={dataSource}
                    showBorders={false}
                    columnAutoWidth={true}
                    width={"100%"}
                    height={"100%"}
                    allowColumnResizing={true}
                    loadPanel={{ enabled: false }}
                    rtlEnabled={props.rtl}
                    repaintChangesOnly={true}
                >
                    <Sorting mode={"single"} />
                    <StateStoring
                        enabled={true}
                        type="localStorage"
                        storageKey={`campaignsStatsTable_${props.identifier}_user${props.id}`}
                    />
                    <Paging enabled={false} />
                    <SearchPanel
                        visible={true}
                        width={240}
                        placeholder={t("search")}
                    />
                    <Scrolling
                        rowRenderingMode={"virtual"}
                        columnRenderingMode={"virtual"}
                    ></Scrolling>
                    <Column cssClass={"align-middle"} dataField="campaignId" visible={false} showInColumnChooser={false} />
                    <Column cssClass={"align-middle"} dataField="campaign" caption={t("campaign")} width={100} />
                    <Column cssClass={"align-middle"} dataField="groupId" visible={false} showInColumnChooser={false} />
                    <Column cssClass={"align-middle"} dataField="group" caption={t("group")} width={100} />
                    <Column cssClass={"align-middle"} dataField="active" caption={t("status")} cellRender={e => e.value ? t("active") : t("inactive")} width={100} />
                    <Column cssClass={"align-middle"} dataField="total" caption={t("total")} width={100} />
                    <Column cssClass={"align-middle"} dataField="available" caption={t("available")} width={100} />
                    <Column cssClass={"align-middle"} dataField="unavailable" caption={t("unavailable")} width={100} />
                    <Column cssClass={"align-middle"} dataField="personalPostponed" caption={t("personalpostponed")} width={100} />
                    <Column cssClass={"align-middle"} dataField="finalized" caption={t("FINALIZED")} width={100} />
                    <Column cssClass={"align-middle"} dataField="processedContactsToday" caption={t("processedtoday")} width={100} />
                    <Column cssClass={"align-middle"} dataField="importedToday" caption={t("importedtoday")} width={100} />
                    <Column cssClass={"align-middle"} dataField="maxRetriesDay" caption={t("maxretriedday")} width={100} />
                    <Column cssClass={"align-middle"} dataField="maxContactsByDay" caption={t("maxcontactsday")} width={100} />
                </DataGrid>
            </div>

            <WidgetSettings key={`settings_${props.identifier}`} activeWidget={props.activeWidget} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setCampaignsFilter={setCampaignsFilter} selectedCampaigns={selectedCampaigns} selectionType={selectionTypes.CAMPAIGNMULTIPLE}></WidgetSettings>

        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        rtl: state.parameters.rtl,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, { removeWidget })(CampaignsStats);